<template>
  <div class="topic-section">
    <div class="container mx-auto px-4 py-12 sm:py-16 max-w-[1800px]">
      <!-- 标题区域 -->
      <div class="section-header">
        <div class="header-content">
          <div class="title-wrapper">
            <h2 class="section-title">文章分类</h2>
            <div class="title-underline"></div>
          </div>
          <p class="section-subtitle">学习一个</p>
        </div>

        <!-- 装饰元素 -->
        <div class="header-decoration">
          <div class="deco-circle deco-1"></div>
          <div class="deco-circle deco-2"></div>
          <div class="deco-circle deco-3"></div>
        </div>
      </div>

      <!-- 主题网格 -->
      <div class="topic-grid">
        <TopicFlipCard v-for="topic in topics" :key="topic.id" :topic="topic" />
      </div>
    </div>
  </div>
</template>

<script>
import TopicFlipCard from "./TopicFlipCard.vue";
import { useTopics } from "@/composables/useTopics";

export default {
  name: "TopicGrid",
  components: {
    TopicFlipCard,
  },
  setup() {
    const { topics } = useTopics();

    return {
      topics,
    };
  },
};
</script>

<style scoped>
.topic-section {
  background: white;
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.topic-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, #e5e7eb, transparent);
}

/* 标题区域 */
.section-header {
  position: relative;
  text-align: center;
  margin-bottom: 3rem;
  padding-bottom: 2rem;
}

.header-content {
  position: relative;
  z-index: 2;
}

.title-wrapper {
  display: inline-block;
  position: relative;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: -0.02em;
}

.title-underline {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 4px;
  background: linear-gradient(
    to right,
    transparent,
    #667eea,
    #764ba2,
    transparent
  );
  border-radius: 2px;
  animation: underline-expand 2s ease-in-out infinite;
}

@keyframes underline-expand {
  0%,
  100% {
    width: 60%;
    opacity: 0.6;
  }
  50% {
    width: 80%;
    opacity: 1;
  }
}

.section-subtitle {
  font-size: 1.125rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
}

/* 装饰元素 */
.header-decoration {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  pointer-events: none;
  z-index: 1;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.1;
}

.deco-1 {
  width: 100px;
  height: 100px;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, #667eea, #764ba2);
  animation: float-1 4s ease-in-out infinite;
}

.deco-2 {
  width: 60px;
  height: 60px;
  top: 20%;
  right: 10%;
  background: linear-gradient(135deg, #f093fb, #f5576c);
  animation: float-2 5s ease-in-out infinite;
}

.deco-3 {
  width: 80px;
  height: 80px;
  bottom: 10%;
  left: 15%;
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  animation: float-3 6s ease-in-out infinite;
}

@keyframes float-1 {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(20px, -20px) rotate(180deg);
  }
}

@keyframes float-2 {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(-15px, 15px) rotate(-180deg);
  }
}

@keyframes float-3 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(10px, -10px) scale(1.2);
  }
}

/* 主题网格 */
.topic-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  position: relative;
}

/* 响应式 */
@media (max-width: 1024px) {
  .topic-grid {
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1rem;
  }

  .topic-grid {
    gap: 1.25rem;
  }

  .header-decoration {
    width: 200px;
    height: 200px;
  }

  .deco-1 {
    width: 70px;
    height: 70px;
  }

  .deco-2 {
    width: 40px;
    height: 40px;
  }

  .deco-3 {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 640px) {
  .section-header {
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
  }
}
</style>
